import { _js } from '@ifixit/localize';
import { ChangeEventHandler } from 'react';
import { SearchInput } from 'Shared/search_input';
import { ExitButton, TitleWithTooltip, HeaderWrapper } from '../UI/lightBoxHeader';
import { PartsList, PartListContainer } from './parts_list';
import MiscPartRow from './miscPartsRow';
import Modal from '../Generic/modal';
import { useSearchContext } from 'Guide/Schematics/Diagram/Providers/searchContext';
import { MinimalDisclosure } from 'Guide/Schematics/Diagram/Logic/minimalDisclosure';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';
import { Flex } from '@chakra-ui/react';

const Header = ({
   onClose,
   title,
   searchText,
   onSeachTextChange,
}: {
   onClose: MinimalDisclosure['onClose'];
   title: string;
   searchText: string;
   onSeachTextChange: ChangeEventHandler<HTMLInputElement>;
}) => (
   <HeaderWrapper
      flexWrap={{ base: 'wrap', sm: 'nowrap' }}
      borderTopLeftRadius="md"
      borderTopRightRadius="md"
   >
      <ExitButton onClick={onClose} aria-label="Close Viewer">
         {_js('Close')}
      </ExitButton>
      <TitleWithTooltip title={title} flexGrow={1} />
      <SearchInput
         value={searchText}
         onChange={onSeachTextChange}
         containerProps={{
            as: Flex,
            marginTop: '16px',
            flexGrow: { base: 1, sm: 0 },
         }}
      />
   </HeaderWrapper>
);

const MiscPartsTable = ({ title, isOpen, onClose }: { title: string } & MinimalDisclosure) => {
   const topMargin = '32px';
   const bottomMargin = '32px';
   const widthMargin = '32px';
   const contentMargin = '32px';

   const searchContext = useSearchContext<iFixitHotSpotItem>();
   const searchText = searchContext.searchText;
   const filteredData = searchContext.filteredData;

   const onSeachTextChange: ChangeEventHandler<HTMLInputElement> = event => {
      searchContext.setSearchText(event.target.value);
   };

   return (
      <Modal isOpen={isOpen} onClose={onClose}>
         <PartListContainer
            marginRight="auto"
            marginTop={topMargin}
            width={`calc(100vw - (2 * ${widthMargin}))`}
            maxWidth={`calc(1028px - (2 * ${widthMargin}))`}
            position="static"
            marginLeft="auto"
         >
            <Header
               onClose={onClose}
               title={title}
               searchText={searchText}
               onSeachTextChange={onSeachTextChange}
            />
            <PartsList
               data={filteredData}
               PartRow={MiscPartRow}
               maxHeight={`calc(100vh - ${topMargin} - (2 * ${bottomMargin}) - ${contentMargin})`}
            />
         </PartListContainer>
      </Modal>
   );
};

export default MiscPartsTable;
